<template>
  <div class="impactpage">
    <div class="desc_part">
      <h3>Our Impact</h3>
      <p v-html="impact_subtitle"></p>
    </div>
    <div class="content_part container row">
      <div
        v-for="post in post_array"
        v-bind:key="post.id"
        class="post col-md-6"
      >
        <h2>{{ post.areas.experience_area }}</h2>
        <p v-html="post.areas.experience_description"></p>
      </div>
    </div>
    <div class="experience_part">
      <h3>Our Industry Experience</h3>
      <div class="container">
        <h4
          v-for="e_tag in experience_tags"
          v-bind:key="e_tag.id"
          v-html="e_tag.industry"
        ></h4>
      </div>
    </div>
    <div class="beforeportfolio container" v-html="impact_subtitle1"></div>
    <div class="portfolio_container">
      <div class="portfolio_part" current="0">
        <div
          v-for="item in portfolio_data"
          v-bind:key="item.id"
          class="col-md-4 portfolio_item item"
          v-bind:style="{ 'background-image': 'url(' + item.image + ')' }"
        >
          <div class="cover">
            <h3 v-html="item.text"></h3>
            <router-link :to="item.link" class="readmore">See Work</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <router-link to="/"><img :src="logo_link" /></router-link>
        <div class="right_part">
          <p>916.658.0144 | 916.658.0155 fax</p>
          <p>980 9th Street, Suite 1480 | Sacramento, CA 95814</p>
          <div class="icons">
            <div class="social-icon">
              <a
                href="https://www.facebook.com/PerryCommunications"
                target="_blank"
                rel="noopener"
                ><font-awesome-icon
                  :icon="['fab', 'facebook-f']"
                  :style="{ color: '#fff' }"
              /></a>
            </div>
            <div class="social-icon">
              <a
                href="https://twitter.com/PerryComGroup"
                target="_blank"
                rel="noopener"
                ><font-awesome-icon
                  :icon="['fab', 'twitter']"
                  :style="{ color: '#fff' }"
              /></a>
            </div>
            <div class="social-icon">
              <a
                href="https://www.linkedin.com/company/perry-communications"
                target="_blank"
                rel="noopener"
                ><font-awesome-icon
                  :icon="['fab', 'linkedin-in']"
                  :style="{ color: '#fff' }"
              /></a>
            </div>
            <div class="social-icon">
              <font-awesome-icon
                :icon="['fas', 'envelope']"
                :style="{ color: '#fff' }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wpData: wpData,
      close_link: "",
      logo_link: "",
      experience_tags: [],
      portfolio_data: [],
      post_array: [],
      impact_subtitle: "",
      impact_subtitle1: "",
    };
  },
  mounted() {
    this.background_link =
      this.wpData.template_directory_uri + "/spa/assets/images/PCG_Holiday20.mp4";
    this.close_link =
      this.wpData.template_directory_uri + "/spa/assets/images/closeIcon.png";
    this.logo_link =
      this.wpData.template_directory_uri + "/spa/assets/images/logoBlk.png";
    fetch(`${this.wpData.rest_url}/wp/v2/pagedata?page_title=Our Impact`)
      .then((res) => res.json())
      .then((data) => {
        console.log("data", data);
        this.impact_subtitle = data.post_content;
        fetch(
          `${this.wpData.rest_url}/wp/v2/acfdata?post_id=${data.ID}&field_name=experience`
        )
          .then((res) => res.json())
          .then((data1) => {
            this.post_array = data1;

            setTimeout(function () {
              $(".experience_part").addClass("shown");
            }, 500);
          });
        fetch(
          `${this.wpData.rest_url}/wp/v2/acfdata?post_id=${data.ID}&field_name=industries`
        )
          .then((res) => res.json())
          .then((data1) => {
            this.experience_tags = data1;
          });
        fetch(
          `${this.wpData.rest_url}/wp/v2/acfdata?post_id=${data.ID}&field_name=our_work_intro`
        )
          .then((res) => res.json())
          .then((data1) => {
            this.impact_subtitle1 = data1;
          });
      });
    fetch(`${this.wpData.rest_url}/wp/v2/postdata?post_name=our_work`)
      .then((res) => res.json())
      .then((data) => {
        for (var i = 0; i < data.length; i++) {
          console.log(data[i]);
          var portfolio = {
            id: data[i].ID,
            text: data[i].post_title,
            image: data[i].featured_image,
            link: "/impact/" + data[i].post_name,
          };
          this.portfolio_data.push(portfolio);
        }
      });
    let router = this.$router;
    $(".btn-introteam").click(function () {
      setTimeout(function () {
        router.push("/team");
      }, 800);
    });
    $(".readmore").click(function () {
      $(".detail_page").removeClass("hidden");
      $(".list_page").addClass("hidden");
    });
    if (this.$route.query.detail == "true") {
      $("html, body").animate(
        {
          scrollTop: $(".footer").offset().top + $(".portfolio_part").height(),
        },
        "slow"
      );
    }

    // const slider = document.querySelector(".portfolio_part");
    // let startX = 0;
    // let scrollLeft = slider.scrollLeft;

    // slider.addEventListener("mousedown", e => {
    //   startX = e.pageX - slider.offsetLeft;
    //   scrollLeft = slider.scrollLeft;
    // });
    // slider.addEventListener("mouseup", (e) => {
    //   e.preventDefault();
    //   const first_slide = $(".portfolio_part .portfolio_item:first-child");
    //   var slide_count = $(".portfolio_part .portfolio_item").length;
    //   var current_slide = parseInt($(".portfolio_part").attr("current"));
    //   console.log(current_slide);
    //   if(e.pageX < startX){
    //     if(current_slide < slide_count-3)
    //       current_slide++;
    //   }else{
    //     if(current_slide > 0){
    //       current_slide--;
    //     }
    //   }
    //   $(".portfolio_part").attr("current", current_slide);
    //   first_slide.animate({marginLeft: -33.33*current_slide + "%"}, 200);
    // });
  },
  methods: {
    gotoMenuPage: function (event) {
      alert("Event1");
    },
  },
};
</script>

<style>
.impactpage {
  position: relative;
  width: 100%;
  padding: 50px 0;
  background: #fff;
  color: #172c62;
}
.desc_part {
  width: 800px;
  margin: 0 auto 70px;
  text-align: center;
}
.desc_part h3 {
  font-size: 45px;
  opacity: 0;
  animation-duration: 1s;
  animation-name: moveup;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
}
.desc_part p {
  font-size: 22px;
  margin-bottom: 0;
}
.content_part {
  margin-bottom: 100px;
}
.impactpage .row {
  margin: auto;
}
.impactpage .post {
  text-align: left;
  margin-bottom: 50px;
}
.impactpage .post h2 {
  font-family: brandingsemibold;
  font-size: 22px;
}
.impactpage .post p {
  font-size: 18px;
  line-height: 30px;
}
.clear {
  clear: both;
}
.experience_part {
  background: #172c62;
  color: #ffffff;
  padding: 60px 0;
  opacity: 0;
}
.experience_part.shown {
  animation-duration: 1s;
  animation-name: moveup;
  animation-delay: 1.4s;
  animation-fill-mode: forwards;
}
.experience_part h3 {
  font-family: brandingsemibold;
  font-size: 42px;
}
.experience_part .container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.experience_part .container h4 {
  font-size: 30px;
  padding: 0;
  margin: 50px 20px 0;
  /*
  animation-duration: 12s;
  animation-name: circular;
  animation-iteration-count: infinite;
  */
}
.beforeportfolio {
  padding: 60px 0;
  opacity: 0;
  animation-duration: 1s;
  animation-name: moveup;
  animation-delay: 1.6s;
  animation-fill-mode: forwards;
}
.beforeportfolio h3 {
  font-size: 30px;
  max-width: 780px;
  margin: auto;
}
.beforeportfolio p {
  margin-top: 50px;
  font-size: 20px;
}
.portfolio_container {
  width: 100%;
  overflow: hidden;
}
.portfolio_part {
  display: flex;
  position: relative;
  flex-wrap: wrap;
  height: auto;
  opacity: 0;
  animation-duration: 1s;
  animation-name: moveup;
  animation-delay: 1.8s;
  animation-fill-mode: forwards;
}
.portfolio_item {
  margin: 0;
  padding: 0;
  height: 380px;
  overflow: hidden;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.col-md-4.portfolio_item img {
  max-width: 120%;
  width: 120%;
  margin-left: -20%;
}
.portfolio_item .cover {
  background: rgba(46, 85, 165, 0.95);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}
.portfolio_item:hover .cover {
  opacity: 1;
}
.portfolio_item .cover h3 {
  font-family: brandingsemibold;
  color: #ffffff;
  text-align: center;
  font-size: 30px;
}
.portfolio_item .cover .readmore {
  width: 147px;
  height: 35px;
  font-size: 20px;
  padding: 0;
  background: none;
  color: #ffffff;
  border: 1px solid #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
}
.portfolio_item .cover .readmore:hover {
  background: #ffffff;
  color: #2e55a5;
}
.footer {
  opacity: 0;
  animation-duration: 1s;
  animation-name: moveup;
  animation-delay: 2.6s;
  animation-fill-mode: forwards;
}
.footer .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 50px;
}
.footer .right_part {
  text-align: right;
}
.footer .right_part p {
  font-size: 13px;
  color: #000;
  margin: 0;
}
.footer .icons {
  display: flex;
  margin-top: 10px;
  justify-content: flex-end;
}
.footer .social-icon {
  background: #333;
  margin-left: 12px;
}
@keyframes moveup {
  from {
    margin-top: 100px;
    opacity: 0;
  }

  to {
    margin-top: 0px;
    opacity: 1;
  }
}
@keyframes movedown {
  from {
    margin-top: 0;
    opacity: 1;
  }

  to {
    margin-top: 100px;
    opacity: 0;
  }
}
@keyframes moveup1 {
  from {
    margin-top: 160px;
    opacity: 0;
  }

  to {
    margin-top: 60px;
    opacity: 1;
  }
}
@keyframes circular {
  0% {
    transform: translatex(0px) translatey(0px) rotate(0deg);
  }
  25% {
    transform: translatey(-10px) rotate(3deg);
  }
  50% {
    transform: translatex(0px) translatey(0px) rotate(0deg);
  }
  75% {
    transform: translatey(-15px) rotate(-3deg);
  }
  100% {
    transform: translatex(0px) translatey(0px) rotate(0deg);
  }
}
@media screen and (max-width: 768px) {
  .desc_part {
    width: 90%;
    margin: 0 auto 50px;
  }
  .beforeportfolio {
    width: 90%;
    margin: 0 auto;
  }
  .portfolio_part {
    height: auto;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppImpact.vue